import joi from "joi";
import { connectToMoengage } from "./connectors/moengage.js";

const configSchema = joi.object({
    production: joi.boolean(),
    autoOpenSearch: joi.boolean(),
    console: joi.boolean(),
    index: joi.string(),
    environment: joi.string(),
    version: joi.string(),
    deviceType: joi.string(),
    origin: joi.string(),
    sourceIPAddress: joi.string(),
    sentry: joi.object({
        dsn: joi.string(),
        environment: joi.string(),
        tracesSampleRate: joi.number(),
        replaysSessionSampleRate: joi.number(),
        replaysOnErrorSampleRate: joi.number(),
        reactRouter: joi.object({
            useEffect: joi.any(),
            useLocation: joi.any(),
            useNavigationType: joi.any(),
            createRoutesFromChildren: joi.any(),
            matchRoutes: joi.any(),
        })
    }),
    moengage: joi.object({
        appId: joi.string(),
        moeDataCenter: joi.string(),
        debugMode: joi.number(),
    }),
})

function getIp() {
    const ipResponse = fetch("https://api.ipify.org?format=json").then(res => res.json())
    return ipResponse.ip
}


export let config = {
    production: false, // enables-disables console.logs
    autoOpenSearch: true, // enables-disables opensearch auto logging
    console: true, // enables-disables console.logs
    index: "farmartapp",
    environment: "development",
    version: "undefined",
    deviceType: "web",
    origin: "script" || window.location.href,
    sourceIPAddress: "undefined"
}

export function setup (newConfig) {
    const { error } = configSchema.validate(newConfig);
    if (error) {
        throw new Error(error);
    }

    config.sourceIPAddress = getIp()

    config = { ...config, ...newConfig };

    if (config.moengage && config.moengage.appId) {
        connectToMoengage(config.moengage);
    }
}